import { FormDesignPreviewAddForm } from "components/Forms/FormDesignPreviewAddForm/FormDesignPreviewAddForm";
import { DataType } from "components/Tables/FormDesignTable/temp";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer.ts";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

interface AddDrawerProps {
    onSubmit: (newData: DataType) => void;
}

export const AddDrawer: FC<AddDrawerProps> = ({ onSubmit }) => {
    const { t } = usePaldockTranslation("drawers.form-design-preview-add");
    const id = DrawerId.FormDesignPreviewAdd;
    const drawerUtils = useDrawer();

    const handleSubmit = async (newData: DataType) => {
        onSubmit(newData);
        drawerUtils.hide(id);
    };

    return (
        <Drawer drawerId={id} title={<DrawerTitle mainTitle={t("title")} />}>
            <FormDesignPreviewAddForm onSubmit={handleSubmit} />
        </Drawer>
    );
};
